/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UpdatePasswordWithTokenRequest model module.
 * @module model/UpdatePasswordWithTokenRequest
 * @version V1
 */
class UpdatePasswordWithTokenRequest {
    /**
     * Constructs a new <code>UpdatePasswordWithTokenRequest</code>.
     * @alias module:model/UpdatePasswordWithTokenRequest
     * @param passwordConfirmation {String} 
     * @param password {String} 
     */
    constructor(passwordConfirmation, password) { 
        
        UpdatePasswordWithTokenRequest.initialize(this, passwordConfirmation, password);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, passwordConfirmation, password) { 
        obj['passwordConfirmation'] = passwordConfirmation;
        obj['password'] = password;
    }

    /**
     * Constructs a <code>UpdatePasswordWithTokenRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UpdatePasswordWithTokenRequest} obj Optional instance to populate.
     * @return {module:model/UpdatePasswordWithTokenRequest} The populated <code>UpdatePasswordWithTokenRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UpdatePasswordWithTokenRequest();

            if (data.hasOwnProperty('passwordConfirmation')) {
                obj['passwordConfirmation'] = ApiClient.convertToType(data['passwordConfirmation'], 'String');
            }
            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UpdatePasswordWithTokenRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UpdatePasswordWithTokenRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of UpdatePasswordWithTokenRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['passwordConfirmation'] && !(typeof data['passwordConfirmation'] === 'string' || data['passwordConfirmation'] instanceof String)) {
            throw new Error("Expected the field `passwordConfirmation` to be a primitive type in the JSON string but got " + data['passwordConfirmation']);
        }
        // ensure the json data is a string
        if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
            throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
        }

        return true;
    }


}

UpdatePasswordWithTokenRequest.RequiredProperties = ["passwordConfirmation", "password"];

/**
 * @member {String} passwordConfirmation
 */
UpdatePasswordWithTokenRequest.prototype['passwordConfirmation'] = undefined;

/**
 * @member {String} password
 */
UpdatePasswordWithTokenRequest.prototype['password'] = undefined;






export default UpdatePasswordWithTokenRequest;

